/* eslint-disable */
import { DEFAULT } from "../../constants";

class MapUtil {
  /**
   * @description Centers the map on a point
   *
   * @param {integer} lat - Latitude
   * @param {integer} lng - Longitude
   * @param {Object} map - Google maps reference
   * @param {Object} google - Google reference
   *
   * @return {void}
   */
  centerMap(lat, lng, map, google) {
    map.panTo(new google.maps.LatLng(lat, lng));
  }

  /**
   * @description Checks if the map has panned out of bounds
   *
   * @param {Object} map - Instance of the Google map
   *
   * @return {void}
   */
  checkBounds(map) {
    const { google } = window;
    if (map) {
      const latNorth = map
        .getBounds()
        .getNorthEast()
        .lat();
      const latSouth = map
        .getBounds()
        .getSouthWest()
        .lat();
      let newLat;

      if (latNorth < 85 && latSouth > -85) return;

      if (latNorth > 85 && latSouth < -85) return;

      if (latNorth > 85) newLat = map.getCenter().lat() - (latNorth - 85);

      if (latSouth < -85) newLat = map.getCenter().lat() - (latSouth + 85);

      if (newLat) {
        const newCenter = new google.maps.LatLng(newLat, map.getCenter().lng());
        map.setCenter(newCenter);
      }
    }
  }

  /**
   * Helpers to set map zoom.
   *
   * @param {Number} zoom - Amount to set map zoom.
   * @param {Number} map - Map zoom.
   */
  setZoom(zoom, map) {
    map.setZoom(zoom);
  }

  /**
   * Converts a Google Maps LatLng object into a JS object representation to be consumed by
   * the redux state.
   *
   * @param {LatLngBounds} bounds - A Google LatLngBounds object.
   * @return {Object} - JS object representation of the LatLngBounds object.
   */
  convertBounds(bounds) {
    const northeast = bounds.getNorthEast();
    const southwest = bounds.getSouthWest();

    return {
      northeast: {
        lat: northeast.lat(),
        lng: northeast.lng()
      },
      southwest: {
        lat: southwest.lat(),
        lng: southwest.lng()
      }
    };
  }

  /**
   * @description Instantiates Google Geocoder class
   *
   * @return {void}
   */
  initGeocoder() {
    const google = window.google;
    this.geocoder = new google.maps.Geocoder();
  }

  /**
   * @description Returns a reference of the Google Geocoder class
   *
   * @return {Object} Instance of geocode for sending geocode requests to Google
   */
  getGeocoder() {
    return this.geocoder;
  }

  /**
   * Retrieves the country based on the center coordinates of the currently visible map. Utilizes
   * the Google reverse geocoding API.
   *
   * @param {Object} map - Google map reference.
   * @return {Promise<String>} A promise, which resolves the two letter country code.
   */
  async getCountry(map) {
    if (!this.geocoder) this.initGeocoder();

    return new Promise((resolve, reject) => {
      try {
        this.geocoder.geocode(
          { location: map.getCenter() },
          (results, status) => {
            let country = null;

            if (status === google.maps.GeocoderStatus.OK) {
              if (results[0]) {
                results[0].address_components.forEach(component => {
                  if (component.types.indexOf("country") >= 0) {
                    country = component.short_name;
                  }
                });
              }
            }

            resolve(country);
          }
        );
      } catch (e) {
        // Do nothing.
      }
    });
  }
}

export default new MapUtil();
